var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgApple(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 16,
    viewBox: "0 0 13 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10694_388064)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.17278 1.39279C8.22053 0.00724308 9.67714 0.000488281 9.67714 0.000488281C9.67714 0.000488281 9.89381 1.30314 8.85293 2.55801C7.74153 3.89793 6.47827 3.67867 6.47827 3.67867C6.47827 3.67867 6.24106 2.62487 7.17278 1.39279ZM6.61153 4.59118C7.15054 4.59118 8.15092 3.84778 9.45306 3.84778C11.6945 3.84778 12.5762 5.44798 12.5762 5.44798C12.5762 5.44798 10.8516 6.33265 10.8516 8.47926C10.8516 10.9008 13 11.7354 13 11.7354C13 11.7354 11.4982 15.9763 9.46975 15.9763C8.53808 15.9763 7.81375 15.3464 6.8321 15.3464C5.83172 15.3464 4.83899 15.9998 4.19242 15.9998C2.34011 15.9999 0 11.9769 0 8.74304C0 5.5614 1.98075 3.89236 3.83861 3.89236C5.04639 3.89236 5.98363 4.59118 6.61153 4.59118Z",
    fill: "#262758"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10694_388064"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 16,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/apple.76398b06af0ed770f8c03b27c61eefdf.svg";
export { ForwardRef as ReactComponent };